import React from 'react'
import { GridLoading } from '../grid-loading'
import {
  RemoteComponent,
  RemoteComponentProps
} from '../remote-component/remote-component'

export const RemoteApp = ({
  fallbackComponent,
  ...props
}: RemoteComponentProps) => {
  const fallback = fallbackComponent || <GridLoading />

  return <RemoteComponent fallbackComponent={fallback} {...props} />
}
